import { desktopHeaderHeight } from '../../components/Header/Header.globals';
export const homeSectionTopSpacing = {
  default: '32px',
  mediaQuery: [['mediumUp', `${desktopHeaderHeight + 32}px`]]
};